import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { QuoteRequestState } from '@app/shared';
import { ConfigService } from '@app/shared/services/config.service';
import { Quote, QuoteState } from '../models/quote';

@Injectable({
  providedIn: 'root',
})
export class QuoteService {
  @Output() quoteRequestStateUpdated = new EventEmitter<QuoteRequestState>();
  @Output() quoteUpdated = new EventEmitter<Quote>();
  @Output() quoteStateUpdated = new EventEmitter<QuoteState>();
  @Output() loadFactorUpdated = new EventEmitter();
  @Output() pricingCurveDate = new EventEmitter();

  constructor(private configService: ConfigService, private httpClient: HttpClient) {}

  public updateQuoteRequest(quote: QuoteRequestState) {
    this.quoteRequestStateUpdated.emit(quote);
  }

  public updateQuote(quote: Quote) {
    this.quoteUpdated.emit(quote);
  }

  public updateQuoteState(quote: QuoteState) {
    this.quoteStateUpdated.emit(quote);
  }

  public updateLoadFactor(quote: Quote) {
    this.loadFactorUpdated.emit(quote);
  }

  public updatePricingCurveDate(quote: Quote) {
    this.pricingCurveDate.emit(quote);
  }

  public addQuote(quoteRequestId: number, term: number, rate: number) {
    const path = this.configService.getApiPath(`generateQuote/${quoteRequestId}/add-quote`);
    return this.httpClient.post(path, {
      term,
      rate,
    });
  }
}
